import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import {Label2} from "@irati/ui/src/Labels"
import TeamListBase from "../../../TeamList"

const TeamListWrapper = styled(Label2).attrs({
  uppercase: true
})`
  color: ${greys.medium};
`

const TeamList = ({teams}) => {
  return (
    <TeamListWrapper>
      <TeamListBase teams={teams} />
    </TeamListWrapper>
  )
}

TeamList.propTypes = {
  teams: PropTypes.array.isRequired
}

export default TeamList
